"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConcurrentPromises = /** @class */ (function () {
    function ConcurrentPromises() {
        this.lastPromiseId = 0;
    }
    ConcurrentPromises.prototype.thenForLast = function (promise) {
        var _this = this;
        var promiseId = ++this.lastPromiseId;
        return promise
            .then(function (response) {
            if (promiseId !== _this.lastPromiseId) {
                return { result: response, wasCancelled: true };
            }
            return { result: response, wasCancelled: false };
        })
            .catch(function (e) {
            if (promiseId !== _this.lastPromiseId) {
                /* note: any then()s chained off this returned promise will execute no matter what after our catch here, so we must return a response */
                return { result: undefined, wasCancelled: true };
            }
            throw e;
        });
    };
    ConcurrentPromises.prototype.thenForLastWithErrorHandling = function (promise, errorHandlers) {
        var _this = this;
        var promiseId = ++this.lastPromiseId;
        /* note: we don't want a throw in the first then to be caught by the network error catch (which it would be if we had an explicit
           catch chained after the then).  By using the onRejected argument of then, any errors thrown inside the onResolved callback will
           not be caught by the network error handler.  Also, trying to put the catch for the network error before the first then causes
           awkward type issues. */
        return promise
            .then(function (response) {
            if (promiseId !== _this.lastPromiseId) {
                return { result: undefined, __wasCancelled: true };
            }
            if (response.ok) {
                return response.json();
            }
            else if (response.status === 404) {
                errorHandlers.handle404Error();
                throw response.status;
            }
            else if (response.status === 403) {
                errorHandlers.handle403Error();
                throw response.status;
            }
            else if (response.status === 401) {
                errorHandlers.handle401Error();
                throw response.status;
            }
            else {
                errorHandlers.handle500Error();
                throw response.status;
            }
        }, function (e) {
            if (promiseId !== _this.lastPromiseId) {
                /* note: any then()s chained off this returned promise will execute no matter what after our catch here, so we must return a response */
                return { result: undefined, __wasCancelled: true };
            }
            errorHandlers.handleNetworkError();
            throw e;
        })
            .then(function (resultOrJson) {
            /* note: we use an "internal" wasCancelled bit property name (__wasCancelled) since the response json may have a property called wasCancelled */
            if (resultOrJson.__wasCancelled) {
                return { result: undefined, wasCancelled: true };
            }
            return { result: resultOrJson, wasCancelled: false };
        });
    };
    return ConcurrentPromises;
}());
exports.ConcurrentPromises = ConcurrentPromises;
